import React, { useEffect, useState, useContext } from 'react';
import TextField from '@mui/material/TextField';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import RemoveCircle from '@mui/icons-material/RemoveCircle';
import styled from 'styled-components';
import HeaderInfoM from '../lib/typography/HeaderInfoM';
import { PlaceStoreContext } from '../reducers/Place/PlaceContext';
import MenuItem from '@mui/material/MenuItem';

const Wrapper = styled.div`
  display: flex;
  justifyContent: center;
  flex-direction: column;
  padding: 15px;
  border 1px solid #CCC;
  border-radius: 6px;
`;

export const EditExtraToppingGroups = ({
  mainToppingGroup,
  extraToppingGroups,
  setFieldValue,
  disabled,
}) => {
  const [placeState] = useContext(PlaceStoreContext);
  const [toppingGroups, setToppingGroups] = useState(extraToppingGroups);
  const [newToppingGroup, setNewToppingGroup] = useState(false);
  const [availableToppingGroups, setAvailableToppingGroups] = useState([]);
  const {
    toppings: { toppingGroupId__toppingsGroups },
  } = placeState;

  useEffect(() => {
    setAvailableToppingGroupsOnChange();
  }, [mainToppingGroup]);

  useEffect(() => {
    setFieldValue('extra_grp', toppingGroups);
    setAvailableToppingGroupsOnChange();
  }, [toppingGroups]);

  const setAvailableToppingGroupsOnChange = () => {
    const newAvailableToppingGroups = [];
    for (const toppingGroupId in toppingGroupId__toppingsGroups) {
      if (!toppingGroups.includes(toppingGroupId) && toppingGroupId !== mainToppingGroup) {
        newAvailableToppingGroups.push(toppingGroupId__toppingsGroups[toppingGroupId]);
      }
    }
    setAvailableToppingGroups(newAvailableToppingGroups.sort((a, b) => a.name.localeCompare(b.name)));
  }

  const handleChangeToppingGroup = (e) => {
    const newToppingGroups = [...toppingGroups, e.target.value];
    setToppingGroups(newToppingGroups);
    setNewToppingGroup(false);
  };

  const handleAddContent = () => {
    setNewToppingGroup(true);
  };

  const handleRemoveContent = (e, index) => {
    const newToppingGroups = [...toppingGroups];
    if (index > -1) {
      newToppingGroups.splice(index, 1);
    }
    setToppingGroups(newToppingGroups);
  };

  const handleRemoveAllContent = (e, index) => {
    setNewToppingGroup(false);
  };

  if (disabled) {
    return (
      <TextField
        required
        fullWidth
        select
        disabled
        required={false}
        variant="outlined"
        label="Extra Toppings Groups Disabled"
        value={''}
      >
        <MenuItem value={''}>
          Disabled
        </MenuItem>
      </TextField>
    );
  }

  return (
    <Wrapper>
      <HeaderInfoM
        name="Be part of extra topping groups"
        size="1rem"
        color="#000000"
        style={{ padding: '2px', letterSpacing: '-0.05em', marginBottom: '10px' }}
      />
      {toppingGroups.map((toppingGroupId, index) => {
        return (
          <div key={index} className="f-c f-aic mb-8">
            <p>{toppingGroupId__toppingsGroups[toppingGroupId]?.name}</p>
            <RemoveCircleIcon
              color="error"
              className="s-24-i ml-8"
              onClick={(e) => handleRemoveContent(e, index)}
            />
          </div>
        );
      })}
      {newToppingGroup && (
        <div style={{ marginBottom: '10px', marginLeft: '3px' }}>
          <TextField
            required
            fullWidth
            select
            variant="outlined"
            label="Select Aditional Category"
            value={''}
            onChange={handleChangeToppingGroup}
          >
            {availableToppingGroups.map((toppingGroup, index) => {
              return (
                <MenuItem key={index} value={toppingGroup.id}>
                  {toppingGroup.name}
                </MenuItem>
              );
            })}
          </TextField>
        </div>
      )}
      <div style={{ display: 'flex' }}>
        {!newToppingGroup && availableToppingGroups.length > 0 && <Fab color="primary" aria-label="add" size="small" onClick={handleAddContent}>
          <AddIcon />
        </Fab>}
        {newToppingGroup && <Fab aria-label="add" size="small" onClick={handleRemoveAllContent} style={{ backgroundColor: 'red', color: 'white'}}>
          <RemoveCircle />
        </Fab>}
      </div>
    </Wrapper>
  );
};
